import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscription-history',
  templateUrl: './subscription-history.component.html',
  styleUrls: ['./subscription-history.component.scss']
})
export class SubscriptionHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
